"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _productConfigurations = require("./productConfigurations");
var _default = exports["default"] = {
  /**
   * CSS class used in the Anypoint Components Popover component to ignore clicks on a child component.
   * See https://github.com/mulesoft/anypoint-components/blob/master/src/components/Popover/Popover.js#L179.
   */
  ignorePopoverClickClass: 'popover-if-clicked-ignore-close',
  defaultSignInLink: '/login/#/signin',
  /**
   * General support items that exist independent of context.
   * @type {[{
   *  name: string,
   *  icon: string,
   *  href: string,
   *  target: string
   * }, ... ]}
   */
  defaultSupportItems: [_productConfigurations.DOCUMENTATION, _productConfigurations.FORUMS, _productConfigurations.HELP_CENTER, _productConfigurations.TRAINING, _productConfigurations.TUTORIALS]
};
//# sourceMappingURL=constants.js.map